export default [
    /* {
        path: '/static/seo-analysis',
        component: () => import('views/modules/cms/seo-analysis/'),
        meta: {
            title: 'seo分析',
            parentId: 0,
        },
    }, */
    {
        path: '/static/seo-analysis/addCompetitor',
        component: () => import('views/modules/cms/seo-analysis/addCompetitor'),
        meta: {
            title: 'seo分析',
            parent: '/cms/seo-analysis',
        },
    },
    {
        path: '/static/seo-tool-seo-help',
        component: () => import('views/modules/cms/seo-tool/seo-help/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: 'SEO工具',
        },
    },
    {
        path: '/static/helper',
        component: () => import('views/modules/cms/seo-tool/helper/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: 'SEO工具助手',
        },
    },
    {
        path: '/static/seo-tool-keywords-detail',
        component: () => import('views/modules/cms/seo-tool/seo-help/keywords-detail.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '关键词详情',
        },
    },
    {
        path: '/static/seo-tool-empty-short',
        component: () => import('views/modules/cms/seo-tool/empty-short/index.vue'),
        meta: {
            parent: '/cms/seo-tool',
            title: '空短页面',
        },
    },
    {
        path: '/static/new-label/list',
        name: 'new-label-list',
        component: () => import('views/modules/cms/new-label/list/index.vue'),
        meta: {
            parent: '/cms/new-label/list',
            title: '标签管理',
        },
    }
];
